// This can be removed after the Address.cshtml partial is removed.
export function AddressController($filter, localeService) {
    'ngInject'
    const self = this;

    self.stateProvinceLabel = $filter("translate")("StateProvince");
    self.postalCodeLabel = $filter("translate")("PostalCode");

    self.changeCountry = changeCountry;
    self.init = init;
    self.options = {
        change: function () {
            changeCountry();
        }
    }

    return;

    function init(addressID, countryID) {
        self.addressID = addressID;
        self.countryID = countryID;

        // Fill in localized label text based on the selected country.
        changeCountry();
    }

    function changeCountry() {
        // Retranslate the state/province and zip/postal based on the locale of the new country.
        localeService.retrieveLocales()
            .then(function (locales) {
                return locales.filter(function (locale) {
                    return locale.countryID === Number(self.countryID);
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                self.countryID = locale.countryID;
                return localeService.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                // Change the label text to that of the selected country.
                self.stateProvinceLabel = translations.StateProvince;
                self.postalCodeLabel = translations.PostalCode;
            });
    }
}
